<template>
  <div style="margin-top: 100px;">
    <div style="display: flex; justify-content: space-around;">
      <img
        style="width: 300px; height: 300px;"
        src="https://i.ibb.co/mRhgC2N/Pngtree-computer-online-shopping-4986603.png"
      />
      <form @submit.prevent="formLogin" class="border shadow" style="padding: 50px;">
        <h4>Login Sekarang!</h4>
        <p>
          Belum punya akun? klik
          <router-link class="text-success" :to="{ name: 'Register' }">Disini</router-link>
        </p>
        <div class="form-group">
          <label for="exampleInputEmail1">Email address</label>
          <input
            v-model="emailLogin"
            type="email"
            class="form-control"
            id="exampleInputEmail1"
            aria-describedby="emailHelp"
            placeholder="Enter email"
          />
          <small
            id="emailHelp"
            class="form-text text-muted"
          >We'll never share your email with anyone else.</small>
        </div>
        <div class="form-group">
          <label for="exampleInputPassword1">Password</label>
          <input
            v-model="passwordLogin"
            type="password"
            class="form-control"
            id="exampleInputPassword1"
            placeholder="Password"
          />
        </div>
        <button style="width: 300px;" type="submit" class="btn btn-success">Login</button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      emailLogin: "",
      passwordLogin: ""
    };
  },
  methods: {
    formLogin() {
      const email = this.emailLogin;
      const password = this.passwordLogin;
      this.$store.dispatch("loginUser", { email, password });
    }
  }
};
</script>

<style>
</style>